<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">委托处置台账</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <div>
          <el-button
            type="primary"
            plain
            @click="exportSome1"
            :disabled="selectedDemand.length === 0"
            >导出所选</el-button
          >
          <el-button type="primary" plain @click="exportEvery"
            >导出全部</el-button
          >
        </div>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @on-select="onSelect"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheckBidFile(scope.row.id)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:bidStatusView="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  class="cell-link"
                  @click="onCheckBidFile(scope.row.newNoticeId)"
                  >{{ scope.row.bidStatusView }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:assetClass="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.assetClass == 1
                    ? '废旧物资'
                    : scope.row.assetClass == 2
                    ? '闲置物资'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:reservePrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.reservePrice">{{
                  scope.row.reservePrice | numberFormat(2)
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:startPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.startPrice">{{
                  scope.row.startPrice | numberFormat(2)
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:markupPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.markupPrice">{{
                  scope.row.markupPrice | numberFormat(2)
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dealPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.dealPrice">{{
                  scope.row.dealPrice | numberFormat(2)
                }}</span>
                <span v-else>{{ scope.row.dealPrice }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:addPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.addPrice">{{
                  scope.row.addPrice | numberFormat(2)
                }}</span>
                <span v-else>{{ scope.row.addPrice }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dealTotalPriceWY="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.dealTotalPriceWY">{{
                  scope.row.dealTotalPriceWY | numberFormat(2)
                }}</span>
                <span v-else>{{ scope.row.dealTotalPriceWY }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:addPrecent="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.addPrecent"
                  >{{ (scope.row.addPrecent * 100) | numberFormat(2) }}%</span
                >
                <span v-else>{{ scope.row.addPrecent }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:shipmentTotalPriceWY="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.shipmentTotalPriceWY">{{
                  scope.row.shipmentTotalPriceWY | numberFormat(2)
                }}</span>
                <span v-else>{{ scope.row.shipmentTotalPriceWY }}</span>
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
  </div>
</template>
<script>
import { daterange, openNewPage } from '@/utils/constantime'
export default {
  data() {
    return {
      removeV: 1,
      pageNum: 1,
      pageSize: 10,
      flag: false,
      selectedDemand: [],
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      formConfig: {
        configs: {
          personName: {
            ...daterange,
            label: '公告发布日期'
          },
          title: {
            tag: 'input',
            label: '公告标题'
          },
          code: {
            tag: 'input',

            label: '公告编号'
          },
          assetClass: {
            tag: 'select',
            label: '物资类型',
            options: [
              { value: 1, label: '废旧物资' },
              { value: 2, label: '闲置物资' }
            ]
          },
          payMethod: {
            tag: 'select',
            label: '货款支付方式',
            default: null,
            //statusCode 0、1、1-1、1-3 可以修改 其他不能修改
            options: [
              { value: null, label: '全部' },
              { value: '1', label: '线下支付' },
              { value: '2', label: '线上支付' }
            ]
          },
          bidStart: {
            ...daterange,
            label: '竞价开始日期'
          },
          bidEndTime: {
            ...daterange,
            label: '竞价结束日期'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      tableConfig: {
        isPagination: true,
        columns: [
          {
            prop: 'selection',
            label: '选择',
            type: 'selection',
            width: '50px',
            align: 'center'
          },
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            slot: 'title',
            prop: 'title',
            label: '公告标题',
            'show-overflow-tooltip': true,
            width: '100px'
          },
          {
            prop: 'code',
            'show-overflow-tooltip': true,
            label: '公告编号',
            align: 'center',
            width: '100px'
          },
          {
            slot: 'assetClass',
            prop: 'assetClass',
            'show-overflow-tooltip': true,
            label: '物资类型',
            align: 'center'
          },
          {
            prop: 'bidCodeName',
            label: '价格类型',
            align: 'center',
            width: '140px'
          },
          {
            slot: 'reservePrice',
            prop: 'reservePrice',
            label: '保留价(元)',
            align: 'center',
            width: '100px',
            'show-overflow-tooltip': true
          },
          {
            slot: 'startPrice',
            prop: 'startPrice',
            label: '开盘价(元)',
            align: 'center',
            'show-overflow-tooltip': true
          },
          {
            slot: 'markupPrice',
            prop: 'markupPrice',
            label: '最低加价幅度(元)',
            align: 'center',
            width: '110px',
            'show-overflow-tooltip': true
          },
          {
            prop: 'publishTime',
            label: '公告发布时间',
            align: 'center',
            // width: '100px'
            width: '160px'
          },
          {
            slot: 'bidStatusView',
            prop: 'bidStatusView',
            label: '重新/终止处置',
            align: 'center',
            // width: '100px'
            width: '160px'
          },

          {
            prop: 'bidStartTime',
            label: '竞价开始时间',
            align: 'center',
            width: '160px'
          },
          {
            prop: 'bidEndTime',
            label: '竞价结束时间',
            align: 'center',
            width: '160px'
          },
          {
            prop: 'scheduleCodeName',
            label: '处置进度',
            align: 'center'
          },
          {
            prop: 'buyerCompName',
            'show-overflow-tooltip': true,
            label: '成交购买商',
            align: 'center',
            width: '100px'
          },
          {
            slot: 'dealPrice',
            prop: 'dealPrice',
            label: '成交价格(元)',
            align: 'center',
            'show-overflow-tooltip': true
          },
          {
            slot: 'addPrice',
            prop: 'addPrice',
            'show-overflow-tooltip': true,
            label: '增值额(元)',
            align: 'center'
          },
          {
            prop: 'addPrecent',
            slot: 'addPrecent',
            'show-overflow-tooltip': true,
            label: '溢价率',
            align: 'center'
          },
          {
            slot: 'dealTotalPriceWY',
            prop: 'dealTotalPriceWY',
            'show-overflow-tooltip': true,
            label: '成交金额(万元)',
            align: 'center'
          },
          {
            slot: 'shipmentTotalPriceWY',
            prop: 'shipmentTotalPriceWY',
            'show-overflow-tooltip': true,
            label: '发货金额(万元)',
            align: 'center'
          },
          {
            prop: 'payMethodView',
            'show-overflow-tooltip': true,
            label: '货款支付方式',
            align: 'center'
          }
        ],
        data: [],
        total: 0
      },
      choose: ''
    }
  },
  created() {
    this.listNotice()
  },
  methods: {
    onSelect(row) {
      this.selectedDemand = row
    },
    async listNotice() {
      let obj = {
        ...this.params
      }
      let data = await this.$api.materialdisposal.listEntrustNotice(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.listNotice()
    },
    onSizeChange(val) {
      this.params = {
        ...this.params,
        pageIndex: 1,
        pageSize: val
      }
      this.listNotice()
    },
    onQuery(val) {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        code: val.code,
        title: val.title,
        assetClass: val.assetClass,
        payMethod: val.payMethod,
        publishTimeStart:
          val.personName && val.personName.length != 0
            ? val.personName[0]
            : null,
        publishTimeEnd:
          val.personName && val.personName.length != 0
            ? val.personName[1]
            : null,
        bidStartTimeEnd:
          val.bidStart && val.bidStart.length != 0 ? val.bidStart[1] : null,
        bidStartTimeStart:
          val.bidStart && val.bidStart.length != 0 ? val.bidStart[0] : null,
        bidEndTimeEnd:
          val.bidEndTime && val.bidEndTime.length != 0
            ? val.bidEndTime[1]
            : null,
        bidEndTimeStart:
          val.bidEndTime && val.bidEndTime.length != 0
            ? val.bidEndTime[0]
            : null
      }
      this.listNotice()
    },
    onReset(val) {
      console.log(val)
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.listNotice()
    },
    onCheckBidFile(id) {
      let query = {
        id: id
      }
      openNewPage('CompileMaterialcheck', query)
    },
    async exportEvery() {
      let res = await this.$api.materialdisposal.exportNotice()
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      let fileName = '公告台账'
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    },
    remove(val) {
      this.removeV = val
    },
    async exportSome1() {
      if (this.selectedDemand.length === 1) {
        this.choose = this.selectedDemand[0].id.toString()
      } else {
        this.selectedDemand.map((item, index) => {
          if (index === 0) {
            this.choose = item.id
          } else {
            this.choose = this.choose + ',' + item.id
          }
        })
      }
      let obj = {
        ids: this.choose
      }
      let res = await this.$api.materialdisposal.exportNotice(obj)
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      let fileName = '公告台账'
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>
